module.exports = __webpack_public_path__ + "img/6.ccba2720.png";